import { useContext } from "react";
import { ConfigStateContext } from "../../../Contexts/Configurations/context";
import {
	showBathrooms,
	showBedrooms,
	showRooms,
	showGuests,
	showM2,
} from "../../../Utils/Functions";

interface useTypologyTagProps {
	propertyType: Number,
	operationType: Number
}

interface useTypologyTagResponse {
	showBedrooms: Boolean,
	showBathrooms: Boolean,
	showRooms: Boolean,
	showGuests: Boolean,
	showM2: Boolean
}

type Hook = (useTypologyTagProps) => useTypologyTagResponse

export const useTypologyTag: Hook = ({ propertyType, operationType }) => {
	const { country_code } = useContext(ConfigStateContext);

	return {
		showBedrooms: showBedrooms([propertyType], operationType, country_code),
		showBathrooms: showBathrooms([propertyType], country_code),
		showRooms: showRooms([propertyType], country_code),
		showGuests: showGuests(operationType),
		showM2: showM2(operationType),
	};
}
